exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._71oEScV0HYqYTZTCXKk9J{position:relative;top:1px}._71oEScV0HYqYTZTCXKk9J button{max-height:20px}", ""]);
// Exports
exports.locals = {
	"weatherIcon": "_71oEScV0HYqYTZTCXKk9J"
};